import { z } from "zod";
import { commentContextSchema } from "../core/people";
export const webhookConnectionInput = z.object({
  id: z.uuid().optional(),
  name: z.string().trim().min(1),
  url: z.string().trim().optional(),
  authorization: z.string().trim().optional(),
  signingSecret: z.string().trim().optional(),
  clearAuthorization: z.boolean().optional(),
  clearSigningSecret: z.boolean().optional(),
  bodyFormat: z.enum(["galaxy", "attio"]).optional(),
});
export const webhookConfigSchema = z.object({
  bodyFormat: z.enum(["galaxy", "attio"]),
});
export { reviewStates as webhookStates } from "../core/review";

import type { reviewStates as webhookStates } from "../core/review";

const webhookRecordBaseSchema = z.object({
  id: z.string(),
  type: z.union([z.literal("person"), z.literal("activity")]),
  source: z.string(),
  observedAt: z.string(),
  title: z.string(),
  url: z.string(),
  body: z.string(),
  commentContext: commentContextSchema.nullable().optional(),
  person: z.union([
    z.object({
      id: z.string(),
      login: z.string(),
      name: z.union([z.string(), z.null()]),
      company: z.union([z.string(), z.null()]),
      location: z.union([z.string(), z.null()]),
      bio: z.union([z.string(), z.null()]),
      url: z.string(),
      avatar: z.string(),
      website: z.union([z.string(), z.null()]).optional(),
      twitterUsername: z.union([z.string(), z.null()]).optional(),
      /** Public profile email first, then distinct commit emails. */
      emails: z.array(z.string()).optional(),
      socialAccounts: z
        .union([z.array(z.object({ provider: z.string(), url: z.string() })), z.null()])
        .optional(),
    }),
    z.null(),
  ]),
  repositories: z.array(z.object({ id: z.string(), name: z.string(), url: z.string() })),
  activity: z.union([
    z.object({
      signal: z.string().optional(),
      type: z.string(),
      kind: z.string(),
      occurredAt: z.union([z.string(), z.null()]),
      observedAt: z.string(),
      baseline: z.boolean(),
    }),
    z.null(),
  ]),
});
export const deliveryActivitySchema = webhookRecordBaseSchema.omit({
  person: true,
  type: true,
});
export const webhookRecordSchema = webhookRecordBaseSchema.extend({
  activities: z.array(deliveryActivitySchema).optional(),
});
export type WebhookRecord = z.infer<typeof webhookRecordSchema>;
export type AttioPersonBody = {
  first_name: string;
  last_name?: string;
  github_username?: string;
  full_name?: string;
  person_id?: string;
  delivery_key?: string;
  github_url?: string;
  phone_number?: string;
  avatar_url?: string;
  company_name?: string;
  location?: string;
  website?: string;
  bio?: string;
  linkedin_url?: string;
  twitter_url?: string;
  source_url?: string;
  note_title?: string;
  note_content?: string;
  /** The person's chosen primary address, else their first available address. */
  email?: string;
  /** Every current address, excluding explicitly removed addresses. */
  emails: string[];
  activity: string;
  signal?:
    | "REPOSITORY_STARRED"
    | "REPOSITORY_FORKED"
    | "REPOSITORY_ISSUE_CREATED"
    | "REPOSITORY_ISSUE_COMMENTED";
};
export type WebhookPayload = {
  outboundBody?: AttioPersonBody;
  schemaVersion: 1;
  id: string;
  event: "record.sent";
  createdAt: string;

  review: {
    state: (typeof webhookStates)[number];
    previousState: string | null;
  };
  record: WebhookRecord;
};
